import axios from "fetch-api/fetch-api";
// import PASentry from "../util/pa-sentry";

export default class SendEventAPI {
  static sendEventWithPayload(eventObj: any) {
    if (!Array.isArray(eventObj) || eventObj.length === 0) {
      return Promise.resolve(true);
    }
    // if (process.env.NEXT_PUBLIC_VAR_ENV === "production") {
    const payload = eventObj.map((event) => {
      const data = event.payload;
      if (event.payload) {
        Object.keys(event.payload).forEach((key) => {
          if (typeof event.payload[key] === "string") {
            data[key] = encodeURIComponent(event.payload[key]);
          }
        });
      }
      return { ...event, payload: data };
    });

    return axios
      .event("/event", payload)
      .catch(() => {
        // PASentry.logException(error, {}, { eventObj, response: error.response });
      });
    // }
    // return new Promise((resolve) => resolve(true));
  }
}
